import styled from 'styled-components';
import { flexbox, alignItems } from '../../styles/helpers/flexbox';

const Body = styled.div(() => `
  border: 1px solid #E6E9EA;
  width: 100%;
  border-radius: 10px;
  text-align: left;
  font-size: 15px;
  padding: 10px;
  box-sizing: border-box;

  .text {
    margin: 0 15px;
    line-height: initial;
  }

  .calendar {
    margin-top: 10px;

    > div {
      display: table;
      margin: 0 auto;
    }
  }

  .show {
    display: block;
  }

  .hide {
    display: none;
  }

  div[class*="ButtonWrapper"],
  p[class*="TimeHeader"],
  #time-selector-date {
    display: none;
  }

  .DateRangePicker .DateRangePickerInput {
    border-color: white !important;
  }

  .DateRangePickerInput_arrow_svg {
    width: 60px;
  }

  .DateRangePicker_picker {
    left: 0 !important;
    top: auto !important;
    bottom: 44px !important;
  }

  .DateInput_input {
    box-sizing: unset !important;
    border-radius: 5px !important;
    border: 1px solid #cfd2d4 !important;
    padding: 6px 4px !important;
    font-size: 14px !important;
    width: 100px !important;
  }

  .DayPickerNavigation_button {
    ${flexbox()};
    ${alignItems('center')};
  }
`);

// eslint-disable-next-line import/prefer-default-export
export { Body };
